export const queries = [
  "(min-width: 1024px)", // isDesktop
  "(min-width: 768px)", // isTab
  "(min-width: 310px)", // isMobile
];
export const queryValues = ["isDesktop", "isTab", "isMobile"];

export const advancedMatching = {};
export const reactPixelOptions = {
  autoConfig: false,
  debug: true,
};
